// src/stone/icons/ECommerce.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var ECommerce = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M1.25 16.625H10v2H1.25zM1.25 3.5h17v2h-17z" }),
      /* @__PURE__ */ jsx("path", { d: "M3.75 1.75c-.273 0-.5.227-.5.5v19.5c0 .273.227.5.5.5h12c.273 0 .5-.227.5-.5v-5.875h2v5.875c0 1.377-1.123 2.5-2.5 2.5h-12a2.504 2.504 0 0 1-2.5-2.5V2.25c0-1.377 1.123-2.5 2.5-2.5h12c1.377 0 2.5 1.123 2.5 2.5v8.125h-2V2.25c0-.273-.227-.5-.5-.5z" }),
      /* @__PURE__ */ jsx("path", { d: "M13.312 17.125a.312.312 0 1 0 0 .625.312.312 0 0 0 0-.625M11 17.438a2.312 2.312 0 1 1 4.625 0 2.312 2.312 0 0 1-4.625 0M21.187 17.125a.312.312 0 1 0 0 .625.312.312 0 0 0 0-.625m-2.312.313a2.312 2.312 0 1 1 4.625 0 2.312 2.312 0 0 1-4.625 0M10.125 6.5h3.089l.33 1.875h9.011l-1.083 6.5h-8.811L11.536 8.5h-1.411zm3.773 3.875.44 2.5h5.44l.416-2.5z" })
    ]
  }
);
var ECommerce_default = ECommerce;

export {
  ECommerce,
  ECommerce_default
};
